import { Adapter as e, getAdapter as o } from "../../../adapter.js";
import { CheckoutSettingsConfigurationAdapter as r } from "./configuration/configuration.adapter.js";
import { CheckoutSettingsModel as i } from "./settings.model.js";
class u extends e {
  adapt(t) {
    return new i({
      configuration: o(r).adapt(t.configuration),
      checkout: t.checkout,
      cart: t.cart
    });
  }
  serialize(t) {
  }
}
export {
  u as CheckoutSettingsAdapter
};
//# sourceMappingURL=settings.adapter.js.map
